import "../../../../src/content/will-graham-christmas/peace-on-earth.scss";
import * as React from 'react';
export default {
  React
};